import "./App.css";
import React from "react";
import "./variables.css";
import { RouterProvider } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import {
  AuthProvider,
  FakeProvider,
} from "./providers/index.js";
import router from "./navigation/router.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Plugin from "./plugin/Plugin.jsx";
import {
  buttonTheme,
  cardTheme,
  colorsTheme,
  inputTheme,
  tagTheme,
} from "./theme";
import { AlertProvider, AssistanceProvider, ChimeMeetingProvider, PluginProviders } from "./plugin/providers";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js";
import { MeetingProvider } from "amazon-chime-sdk-component-library-react";

Amplify.configure({
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
      signUpVerificationMethod: "code",
    },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const webappTheme = extendTheme({
  colors: colorsTheme,
  components: {
    Button: buttonTheme,
    Card: cardTheme,
    Input: inputTheme,
    Tag: tagTheme,
  },
});

function App() {
  return (
    <I18nextProvider i18n={i18n} defaultNS={"translations"}>
      <ChakraProvider theme={webappTheme}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <div className="App">
                <FakeProvider>
                  <AssistanceProvider>
                    <AlertProvider>
                      <MeetingProvider>
                        <ChimeMeetingProvider>
                          <RouterProvider router={router} />
                          <PluginProviders>
                            <Plugin />
                          </PluginProviders>
                        </ChimeMeetingProvider>
                      </MeetingProvider>
                    </AlertProvider>
                  </AssistanceProvider>
                </FakeProvider>
            </div>
          </AuthProvider>
        </QueryClientProvider>
      </ChakraProvider>
    </I18nextProvider>
  );
}

export default App;
